export default class CheckConsentRequest {
    constructor(public clientId?: string, public responseType?: string, public redirectUri?: string) {
    }
}
